import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import { Tooltip } from '@mui/material';
import { ASSETS } from '../../../../../../assets';
import { THEME } from '../../../../../../themes';
import { Subtitle1Font } from '../../../../../../themes/fonts';

export const Content = styled.div`
  color: ${THEME.COLORS.CONTENT_A};
  ${Subtitle1Font};
  font-weight: 600;
  line-height: normal;
`;

export const Icon = styled(ASSETS.QUOTE_FILL)``;

// todo: change to our conventions
export const TooltipBubble = withStyles({
  tooltip: {
    color: `${THEME.COLORS.SURFACE_PRIMARY}`,
    backgroundColor: `${THEME.COLORS.PRIMARY_DARK}`,
    padding: `${THEME.SPACING.TINY}`,
    fontSize: '12px',
    position: 'relative',
    maxWidth: '480px',
    maxHeight: '240px',
    lineHeight: 1.5,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
})(Tooltip);
